import { render, staticRenderFns } from "./Manage-Salary-Type.vue?vue&type=template&id=51bff7a4"
import script from "./Manage-Salary-Type.vue?vue&type=script&lang=js"
export * from "./Manage-Salary-Type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports